import PropTypes from 'prop-types';
import './scroll-3d-text.css';
import ScrollFloat from './ScrollFloat';

// Render the same 3D text style but animate characters using ScrollFloat
const Scroll3DText = ({ text = 'React Bits' }) => {
  return (
    <div className="scroll-3d-text-container">
      <ScrollFloat
        animationDuration={1}
        ease="back.inOut(2)"
        scrollStart="center bottom+=50%"
        scrollEnd="bottom bottom-=40%"
        stagger={0.03}
        // Use existing 3D text styles to keep the exact size/appearance
        containerClassName=""
        textClassName="scroll-3d-text-main"
        as="div"
      >
        {text}
      </ScrollFloat>
    </div>
  );
};

Scroll3DText.propTypes = {
  text: PropTypes.string,
};

export default Scroll3DText;